module.exports = __webpack_public_path__ + "media/icons/offer-details-przyczepy-d20a8226.png";